module.exports = {
  title: 'CPS国际物流有限公司',
  /**
   * 登录时的登录类型（Merchant：卖家中心）
   */
  portalType: 'Merchant'
}



// WEBPACK FOOTER //
// ./src/setting.js